export const declOfNum = (number, titles) => {  
  const cases = [2, 0, 1, 1, 1, 2];
  const title = titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
  return `${number} ${title}`;  
}

export const numberByThousands = number => {
  return number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : "0";
}

export const shortFullName = fullName => {
  const t = fullName.split (' ');
  if (t.length === 1) {
    return fullName;
  }
  let shortName = '';
  t.map((partName, index) => index === 0 
    ? shortName += partName + ' '
    : shortName += partName.length > 2 ? partName[0] + '.' : partName
  );
  return shortName;
}

export const formatPhoneNumber = str => {
  //Filter only numbers from the input
  let cleaned = ('' + str).replace(/\D/g, '');
  
  //Check if the input is of correct
  let match = cleaned.match(/^(7|8|)?(\d{3})(\d{3})(\d{2})(\d{2})$/);
  
  if (match) {
    //Remove the matched extension code
    //Change this to format for any country code.
    let intlCode = match[1];
    if (intlCode !== '8') {
      intlCode = `+${intlCode}`
    }
    return [intlCode, ' (', match[2], ') ', match[3], '-', match[4], '-', match[5]].join('')
  }
  
  return null;
}

export const preparePhoneNumber = str => {
  //Filter only numbers from the input
  let cleaned = ('' + str).replace(/\D/g, '');
  
  //Check if the input is of correct
  let match = cleaned.match(/^(7|8|)?(\d{10})$/);
  
  if (match) {
    //Remove the matched extension code
    //Change this to format for any country code.
    let intlCode = match[1];
    if (!intlCode || intlCode === '8') {
      intlCode = '7';
    }
    return [intlCode, match[2]].join('')
  }
  
  return cleaned;
}